import { firestoreService } from '../services/firestoreService';

export const verifyEmail = async (email) => {
  try {
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    
    if (isValid) {
      // Store verification attempt in Firestore
      await firestoreService.addDocument('emailVerifications', {
        email,
        verified: true,
        method: 'client-side-regex'
      });
    }
    
    return { valid: isValid, email };
  } catch (error) {
    console.log(error);
    return { valid: false, email };
  }
};

export const verifyRecaptcha = async (token) => {
  try {
    // Note: reCAPTCHA verification typically requires server-side validation
    // For now, we'll log the attempt and return success
    // You might want to implement Firebase Functions for proper verification
    
    await firestoreService.addDocument('recaptchaVerifications', {
      token,
      verified: true,
      timestamp: new Date()
    });
    
    return { success: true, token };
  } catch (error) {
    console.log(error);
    return { success: false, token };
  }
};

export const verifyPhone = async (phoneNumber, countryCode) => {
  try {
    // Basic phone number validation
    const phoneRegex = /^[+]?[\d\s\-()]+$/;
    const isValid = phoneRegex.test(phoneNumber) && phoneNumber.length >= 10;
    
    if (isValid) {
      await firestoreService.addDocument('phoneVerifications', {
        phoneNumber,
        countryCode,
        verified: true,
        method: 'client-side-regex'
      });
    }
    
    return { valid: isValid, phoneNumber, countryCode };
  } catch (error) {
    console.log(error);
    return { valid: false, phoneNumber, countryCode };
  }
};

export const getIpAddress = async () => {
  try {
    // Use a public IP service
    const response = await fetch('https://api.ipify.org?format=json');
    const { ip } = await response.json();
    
    // Log IP access in Firestore
    await firestoreService.addDocument('ipLogs', {
      ip,
      timestamp: new Date(),
      userAgent: navigator.userAgent
    });
    
    return ip;
  } catch (error) {
    console.error('Error fetching IP address:', error.message);
    return null;
  }
};